import { render, staticRenderFns } from "./OtherUserGroupList.vue?vue&type=template&id=af5fcbfc&scoped=true&lang=pug"
import script from "./OtherUserGroupList.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupList.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupList.vue?vue&type=style&index=0&id=af5fcbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5fcbfc",
  null
  
)

export default component.exports